/* eslint-disable camelcase */
/* eslint-disable import/prefer-default-export */

import { modules } from "byzantine";
import { memo, useEffect, useState } from "react";
import { ScrollingIframe } from "cerulean";

// Positive Pay vendors (FIS, AFS) do not load the iframe-resizer child script,
// so the iframe never grows past the 600px default. Fill the viewport below the
// page header instead, keeping 600px as the floor for short windows.
export const POSITIVE_PAY_IFRAME_HEIGHT = "max(600px, calc(100vh - 200px))";

const PositivePay = () => {
  const { fetchHTML } = modules.positivePay.useFetchPositivePayHTML();

  const [htmlBlock, setHtmlBlock] = useState<string>();

  useEffect(() => {
    fetchHTML({
      onData: ({ positive_pay_form }) => {
        const html = atob(positive_pay_form);
        setHtmlBlock(html);
      },
    });
  }, []);

  return (
    <ScrollingIframe
      title="Positive Pay"
      srcDoc={htmlBlock}
      height={POSITIVE_PAY_IFRAME_HEIGHT}
    />
  );
};

export default memo(PositivePay);
